export default {
  "status": {
    "runtime": {
      "completed": true
    },
    "errors": {
      "data": {
        "code": "",
        "description": ""
      }
    }
  },
  "response": {
    "data": [
      {
        "tag": "agora",
        "description": "Agor&agrave;"
      },
      {
        "tag": "altro",
        "description": "Altro"
      },
      {
        "tag": "auchan",
        "description": "Auchan"
      },
      {
        "tag": "bennet",
        "description": "Bennet"
      },
      {
        "tag": "billa",
        "description": "Billa"
      },
      {
        "tag": "carrefour",
        "description": "Carrefour"
      },
      {
        "tag": "cedas",
        "description": "Cedas"
      },
      {
        "tag": "conad",
        "description": "Conad"
      },
      {
        "tag": "coop-ipercop",
        "description": "Coop/Ipercoop"
      },
      {
        "tag": "crai",
        "description": "Crai"
      },
      {
        "tag": "despar",
        "description": "Despar"
      },
      {
        "tag": "dimeglio",
        "description": "Dimeglio"
      },
      {
        "tag": "esselunga",
        "description": "Esselunga"
      },
      {
        "tag": "eurospin",
        "description": "Eurospin"
      },
      {
        "tag": "famila",
        "description": "Famila"
      },
      {
        "tag": "finiper",
        "description": "Finiper"
      },
      {
        "tag": "gruppo-lombardini",
        "description": "Gruppo Lombardini"
      },
      {
        "tag": "il-gigante",
        "description": "Il Gigante"
      },
      {
        "tag": "interdis",
        "description": "Interdis"
      },
      {
        "tag": "iper-la-grande-i",
        "description": "Iper La Grande I"
      },
      {
        "tag": "md-discount",
        "description": "Md Discount"
      },
      {
        "tag": "metro",
        "description": "Metro"
      },
      {
        "tag": "pam",
        "description": "Pam"
      },
      {
        "tag": "panorama",
        "description": "Panorama"
      },
      {
        "tag": "penny",
        "description": "Penny"
      },
      {
        "tag": "rossetto",
        "description": "Rossetto"
      },
      {
        "tag": "selex",
        "description": "Selex"
      },
      {
        "tag": "sidis",
        "description": "Sidis"
      },
      {
        "tag": "sigma",
        "description": "Sigma"
      },
      {
        "tag": "simply",
        "description": "Simply"
      },
      {
        "tag": "sisa",
        "description": "Sisa"
      },
      {
        "tag": "supermercati-gs",
        "description": "Supermercati GS"
      },
      {
        "tag": "unes",
        "description": "Unes"
      }
    ]
  }
}